import React from "react";
import classNames from "classnames/bind";
import styles from "./Table.module.css";

const cx = classNames.bind(styles);
const Table = ({ colum = [], data = [],onClick }) => {
  const handleClick = (data)=>{
    if(onClick){
      onClick(data)
    }
  }
  return (
    <table className={cx("table")}>
      <thead>
        <tr>
          {colum.map((item, index) => {
            return <th key={index}>{item.label}</th>;
          })}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => {
          return (
            <tr style={item.has_event ?{background:"#cad2f1"}:{}} onClick={()=>handleClick(item)} key={index}>
              {colum.map((cl, index) => {
                return <td key={index}>{item[cl.key]}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default Table;
